type State = {
	oldPassword: { value: string; showPassword: boolean };
	newPassword: { value: string; showPassword: boolean };
	confirmNewPassword: { value: string; showPassword: boolean };
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string }
	| { type: 'TOGGLE_SHOW_PASSWORD'; field: string };

export const changePasswordFormInitialState = {
	oldPassword: { value: '', showPassword: false },
	newPassword: { value: '', showPassword: false },
	confirmNewPassword: { value: '', showPassword: false },
};

export const changePasswordReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			return {
				...state,
				[action.field]: { ...state[action.field as keyof typeof state], value: action.payload },
			};
		case 'TOGGLE_SHOW_PASSWORD':
			return {
				...state,
				[action.field]: {
					...state[action.field as keyof typeof state],
					showPassword: !state[action.field as keyof typeof state].showPassword,
				},
			};
	}
};
